import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { errorText } from "../lib/api";

export default function PaymentCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const id = params.get("id");
        if (!id) {
            setError("لا توجد بيانات دفع");
            return;
        }
        api.post("/payments/verify", { payment_id: id })
            .then((r) => {
                const { order_number, payment_status } = r.data;
                if (payment_status === "paid") {
                    navigate(`/order/${order_number}`, { replace: true });
                } else {
                    const msg = params.get("message") || r.data.message || "";
                    navigate(`/pay/${order_number}?failed=1&message=${encodeURIComponent(msg)}`, { replace: true });
                }
            })
            .catch((e) => setError(errorText(e, "تعذر التحقق من الدفع")));
    }, [params, navigate]);

    return (
        <div data-testid="payment-callback-page" className="max-w-md mx-auto px-4 py-16 text-center">
            {!error ? (
                <>
                    <i className="fa-solid fa-spinner fa-spin text-3xl text-brand" />
                    <p className="mt-3 text-text-muted font-bold">جاري التحقق من عملية الدفع...</p>
                </>
            ) : (
                <div className="surface-card p-6" data-testid="payment-callback-error">
                    <p className="text-red-600 font-bold">{error}</p>
                    <Link to="/" className="btn-brand inline-block mt-4">العودة للرئيسية</Link>
                </div>
            )}
        </div>
    );
}
